export const determineAttachmentName = attachment => {
  const desc = attachment.document_description?.trim();
  const type = attachment.document_type?.trim();
  if (desc && type) return `${desc} — ${type}`;
  return desc || type || attachment.document_name;
};

export const isLocked = (lockedBy, lockedStatus) => {
  return lockedBy?.length > 0 || !!lockedStatus;
};
